import { useEffect, useRef, useState } from 'react';

/* Állapotpont tooltippel: forrás + frissítés ideje.
   Asztalon ráhúzásra, érintőképernyőn koppintásra nyílik. A tooltip
   position: fixed, mert a kezdőlap oszlopai görgethetők (overflow: auto),
   és egy abszolút pozicionált buborékot levágnának. */

const W = 240;

export default function StatusDot({ status, label, lines = [], className = '' }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const ref = useRef(null);
  const touch = useRef(typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0));

  const show = () => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const left = Math.min(Math.max(8, r.left + r.width / 2 - W / 2), window.innerWidth - W - 8);
    setPos({ left, top: r.bottom + 6 });
    setOpen(true);
  };

  useEffect(() => {
    if (!open) return;
    const close = e => { if (!ref.current?.contains(e.target)) setOpen(false); };
    const hide = () => setOpen(false);
    document.addEventListener('mousedown', close);
    document.addEventListener('touchstart', close);
    window.addEventListener('scroll', hide, true);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('touchstart', close);
      window.removeEventListener('scroll', hide, true);
    };
  }, [open]);

  const text = [label, ...lines].filter(Boolean);

  return (
    <button
      ref={ref} type="button" className={`hm-dotbtn ${className}`}
      aria-label={text.join('. ')} aria-expanded={open}
      onMouseEnter={() => { if (!touch.current) show(); }}
      onMouseLeave={() => { if (!touch.current) setOpen(false); }}
      onFocus={() => { if (!touch.current) show(); }} onBlur={() => setOpen(false)}
      onClick={e => { e.stopPropagation(); if (touch.current && open) setOpen(false); else show(); }}
    >
      <span className={`hm-dot hm-dot-${status}`} />
      {open && pos && (
        <span role="tooltip" className="hm-tip" style={{ left: pos.left, top: pos.top, width: W }}>
          {text.map((t, i) => <span key={i} className={i === 0 ? 'hm-tip-head' : undefined}>{t}</span>)}
        </span>
      )}
    </button>
  );
}
